/**
 * WhatsApp Broadcast Configuration
 *
 * Canal de difusión de WhatsApp — suscripción mensual con checkout MercadoPago.
 * Sin email input: el checkout pide los datos directamente en MP.
 * Tras el pago el usuario es redirigido a /registro para crear su cuenta y esperar el link.
 *
 * Env vars (todas opcionales, con defaults razonables):
 *   VITE_WHATSAPP_BROADCAST_PRICE_ARS     (precio mensual ARS, e.g. 6999)
 *   VITE_WHATSAPP_BROADCAST_HERO_TITLE    (título del hero)
 *   VITE_WHATSAPP_BROADCAST_HERO_TAGLINE  (subtítulo del hero)
 *   VITE_WHATSAPP_BROADCAST_INTRO         (párrafo intro)
 *   VITE_WHATSAPP_BROADCAST_QUOTE         (cita personal)
 *   VITE_WHATSAPP_BROADCAST_BG_IMAGE      (URL imagen de fondo)
 */

export interface WhatsAppBroadcastConfig {
  priceARS: number;
  backgroundImageUrl?: string;
}

export const WHATSAPP_BROADCAST_CONFIG: WhatsAppBroadcastConfig = {
  priceARS: parseFloat(
    (import.meta.env.VITE_WHATSAPP_BROADCAST_PRICE_ARS as string | undefined) || "6999",
  ),
  backgroundImageUrl:
    (import.meta.env.VITE_WHATSAPP_BROADCAST_BG_IMAGE as string | undefined) || undefined,
};
